import { CropperrDevelopmentsComponent } from "./developments/create-edit-developments/multimedia/cropperr/cropperr.component";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ListComponent } from "./list/list.component";
import { CreateEditComponent } from "./create-edit/create-edit.component";
import { PropertiesRoutingModule } from "./properties-routing.module";
import { SharedModule } from "src/app/shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  NgbNavModule,
  NgbPaginationModule,
  NgbAccordionModule,
  NgbCollapseModule,
  NgbTooltipModule,
  NgbDropdownModule,
  NgbCarouselModule,
} from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { FlatpickrModule } from "angularx-flatpickr";
import { NgxMaskModule } from "ngx-mask";

// Simplebar
import { SimplebarAngularModule } from "simplebar-angular";
// Leaflet Map
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";

import { MultimediaComponent } from "./create-edit/multimedia/multimedia.component";
import { ImageCropperModule } from "ngx-image-cropper";

import { LightboxModule } from "ngx-lightbox";
import { DetailsComponent } from "./create-edit/details/details.component";
import { AddressComponent } from "./create-edit/address/address.component";
import { AreasNearbyComponent } from "./create-edit/areas-nearby/areas-nearby.component";
import { CharateristicsComponent } from "./create-edit/charateristics/charateristics.component";
import { AdvertisementComponent } from "./create-edit/advertisement/advertisement.component";
import { CropperrComponent } from "./create-edit/multimedia/cropperr/cropperr.component";

// Load Icon
import { defineLordIconElement } from "lord-icon-element";
import lottie from "lottie-web";
import { AgentsComponent } from "./create-edit/agents/agents.component";
import { ContactsComponent } from "./create-edit/contacts/contacts.component";
import { ContactsListComponent } from "./create-edit/contacts/contacts-list/contacts-list.component";
import { ContactsCreateEditComponent } from "./create-edit/contacts/contacts-create-edit/contacts-create-edit.component";
import { PortalsComponent } from "./create-edit/portals/portals.component";
import { TranslateModule } from "@ngx-translate/core";
// Range Slider
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { DocumentsComponent } from "./create-edit/documents/documents.component";
import { MomentModule } from "ngx-moment";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { ProposalsComponent } from "./create-edit/proposals/proposals.component";
import { VisitReviewsComponent } from "./create-edit/visit-reviews/visit-reviews.component";
import { ListDevelopmentsComponent } from "./developments/list-developments/list-developments.component";
import { CreateEditDevelopmentsComponent } from "./developments/create-edit-developments/create-edit-developments.component";
import { DetailsDevelopmentsComponent } from "./developments/create-edit-developments/details/details.component";
import { AddressDevelopmentsComponent } from "./developments/create-edit-developments/address/address.component";
import { AreasNearbyDevelopmentsComponent } from "./developments/create-edit-developments/areas-nearby/areas-nearby.component";
import { AdvertisementDevelopmentsComponent } from "./developments/create-edit-developments/advertisement/advertisement.component";
import { AgentsDevelopmentsComponent } from "./developments/create-edit-developments/agents/agents.component";
import { ContactsDevelopmentsComponent } from "./developments/create-edit-developments/contacts/contacts.component";
import { ContactsListDevelopmentsComponent } from "./developments/create-edit-developments/contacts/contacts-list/contacts-list.component";
import { ContactsCreateEditDevelopmentsComponent } from "./developments/create-edit-developments/contacts/contacts-create-edit/contacts-create-edit.component";
import { PortalsDevelopmentsComponent } from "./developments/create-edit-developments/portals/portals.component";
import { DocumentsDevelopmentsComponent } from "./developments/create-edit-developments/documents/documents.component";
import { ProposalsDevelopmentsComponent } from "./developments/create-edit-developments/proposals/proposals.component";
import { VisitReviewsDevelopmentsComponent } from "./developments/create-edit-developments/visit-reviews/visit-reviews.component";
import { MultimediaDevelopmentsComponent } from "./developments/create-edit-developments/multimedia/multimedia.component";
import { UnitsComponent } from "./developments/create-edit-developments/units/units.component";
import { AiDocWizardComponent } from "./create-edit/ai-doc-wizard/ai-doc-wizard.component";
import { AiExtractionModule } from "./create-edit/ai-extraction/ai-extraction.module";
import { SavedPropertyFiltersComponent } from "./components/saved-property-filters/saved-property-filters.component";
import { PropertyHistoryComponent } from "./components/property-history/property-history.component";

@NgModule({
  declarations: [
    ListComponent,
    CreateEditComponent,
    MultimediaComponent,
    DetailsComponent,
    AddressComponent,
    AreasNearbyComponent,
    CharateristicsComponent,
    AdvertisementComponent,
    CropperrComponent,
    AgentsComponent,
    ContactsComponent,
    ContactsListComponent,
    ContactsCreateEditComponent,
    PortalsComponent,
    DocumentsComponent,
    ProposalsComponent,
    VisitReviewsComponent,
    ListDevelopmentsComponent,
    CreateEditDevelopmentsComponent,
    DetailsDevelopmentsComponent,
    AddressDevelopmentsComponent,
    AreasNearbyDevelopmentsComponent,
    AdvertisementDevelopmentsComponent,
    CropperrDevelopmentsComponent,
    AgentsDevelopmentsComponent,
    ContactsDevelopmentsComponent,
    ContactsListDevelopmentsComponent,
    ContactsCreateEditDevelopmentsComponent,
    PortalsDevelopmentsComponent,
    DocumentsDevelopmentsComponent,
    ProposalsDevelopmentsComponent,
    VisitReviewsDevelopmentsComponent,
    MultimediaDevelopmentsComponent,
    UnitsComponent,
    AiDocWizardComponent,
    SavedPropertyFiltersComponent,
    PropertyHistoryComponent,
  ],
  imports: [
    CommonModule,
    PropertiesRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgbPaginationModule,
    NgbNavModule,
    NgSelectModule,
    FlatpickrModule.forRoot(),
    AiExtractionModule,
    NgxMaskModule.forRoot(),
    LeafletModule,
    NgbAccordionModule,
    NgbCollapseModule,
    CKEditorModule,
    ImageCropperModule,
    LightboxModule,
    NgbTooltipModule,
    NgbDropdownModule,
    SimplebarAngularModule,
    TranslateModule,
    NgxSliderModule,
    MomentModule,
    DragDropModule,
    NgbCarouselModule,
    SharedModule
  ],
  exports: [ListComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PropertiesModule {
  constructor() {
    defineLordIconElement(lottie.loadAnimation);
  }
}
